
import React from 'react';

interface HeaderProps {
  onHome: () => void;
}

const Header: React.FC<HeaderProps> = ({ onHome }) => {
  const openSearch = () => {
    if ((window as any).openSearch) (window as any).openSearch();
  };

  const toggleMenu = () => {
    if ((window as any).toggleExpandableMenu) (window as any).toggleExpandableMenu();
  };

  return (
    <div className="sandbox-header-top-wrapper">
      <nav className="sandbox-nav-main w-full">
        <div className="nav-container">
          
          <div className="nav-logo-area">
            <a 
              href="https://www.queenofclean.blog/" 
              className="logo-circle-wrapper"
              onClick={(e) => {
                // If they are on the content studio, we want to reset the view
                if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
                  // We only prevent default if the user is staying on the tool to reset the state
                  // Otherwise, let them navigate away to the real home page.
                  onHome();
                }
              }}
            >
              <img src="https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/b6e3f7d7-2254-425b-b8bc-afb27d2d52db/Gemini_Generated_Image_32texm32texm32te.png?content-type=image%2Fpng" 
                   alt="Lynsey Queen of Clean Logo" 
                   className="header-logo"
                   fetchPriority="high" />
            </a>
          </div>

          <div className="nav-and-social-group">
            
            <button className="menu-pill-toggle" onClick={toggleMenu}>
              <span id="menuText">Menu</span> <i className="fa-solid fa-chevron-down" id="menuChevron"></i>
            </button>

            <ul className="nav-links" id="expandableLinks">
              <li><a href="https://www.queenofclean.blog/" className="nav-btn">Home</a></li>
              <li><a href="https://www.queenofclean.blog/cleaning-tips" className="nav-btn">Cleaning Tips</a></li>
              <li><a href="https://www.queenofclean.blog/laundry" className="nav-btn">Laundry</a></li>
              <li><a href="https://www.queenofclean.blog/recipes" className="nav-btn">Recipes</a></li>
              <li><a href="https://www.queenofclean.blog/videos" className="nav-btn">Videos</a></li>
              <li><a href="https://www.queenofclean.blog/christmas" className="nav-btn">Christmas</a></li>
              <li><a href="https://www.queenofclean.blog/planners" className="nav-btn">Planners</a></li>
              <li><a href="https://lynsey-s-best-buys-443089853457.us-west1.run.app/" className="nav-btn">Store</a></li>
            </ul>

            <div className="social-wrapper">
              <div className="social-links">
                <button className="social-btn search-trigger-btn" onClick={openSearch} aria-label="Open Search">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
                
                <a href="https://www.facebook.com/lynseyqueenofclean" target="_blank" className="social-btn" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
                <a href="https://www.instagram.com/lynsey_queenofclean" target="_blank" className="social-btn" aria-label="Instagram"><i className="fa-brands fa-instagram"></i></a>
                <a href="https://www.amazon.co.uk/shop/lynsey_queenofclean" target="_blank" className="social-btn" aria-label="Amazon"><i className="fa-brands fa-amazon"></i></a>
                <a href="https://www.tiktok.com/@lynsey_queenofclean" target="_blank" className="social-btn" aria-label="TikTok"><i className="fa-brands fa-tiktok"></i></a>
                <a href="https://uk.pinterest.com/lynsey_queenofclean" target="_blank" className="social-btn" aria-label="Pinterest"><i className="fa-brands fa-pinterest-p"></i></a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
